import getHostname from './get-hostname'

/** The develop web app host. Its first label names the environment, not a workspace. */
export const developHostname = 'develop.cwork.io'

/**
 * Checks whether a subdomain identifies a workspace.
 * @param {string | null} subdomain
 * @returns {boolean}
 */
export function isCustomWorkspaceSubdomain(subdomain: string | null): boolean {
  return !!subdomain && !['www', 'login', 'integrations', 'app'].includes(subdomain.toLowerCase())
}

/**
 * Gets the workspace label, excluding generic and runner hosts.
 * @param {string} hostname
 * @returns {string | null}
 */
export function getWorkspaceSubdomain(hostname: string): string | null {
  const host = hostname.toLowerCase()
  const parts = host.split('.')

  if (parts.length !== 3 || host === getHostname(host) || host === developHostname || parts[0] === 'api') {
    return null
  }

  return isCustomWorkspaceSubdomain(parts[0]) ? parts[0] : null
}
